import { IAppState, INITIAL_STATE } from './IAppState';
import * as actions from "./actions";
import { Reducer } from "redux";

export const reducer: Reducer<IAppState> = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        // reset store
        case actions.RESET_STORE:
            return Object.assign({}, state, JSON.parse(JSON.stringify(INITIAL_STATE)));
        //actions
        case actions.UPDATE_USER_DETAILS:
            return Object.assign({}, state, {
                userDetails: action.query
            });
        case actions.UPDATE_USER_TOKEN:
            return Object.assign({}, state, {
                userToken: action.query
            });
        case actions.UPDATE_GUEST_TOKEN:
            return Object.assign({}, state, {
                guestToken: action.query
            });
        case actions.UPDATE_LOGIN_STATUSS:
            return Object.assign({}, state, {
                isUserLogin: action.query
            });
        case actions.UPDATE_FAMILY_DETAILS:
            return Object.assign({}, state, {
                familydetails: action.query
            });
        case actions.UPDATE_WA_OPTIN_STATE:
            return Object.assign({}, state, {
                whatsappOptInState: action.query
            });
        case actions.UPDATE_WALLET_DATA:
            return Object.assign({}, state, {
                walletDetails: action.query
            });
        case actions.UPDATE_SUBSCRIPTION_DATA:
            return Object.assign({}, state, {
                subscriptionData: action.query
            });
        case actions.UPDATE_REVIEWS:
            return Object.assign({}, state, {
                reviews: action.query
            });
        case actions.UPDATE_PROFILE_STATUS:

            return Object.assign({}, state, {
                isProfileComplete: action.query
            });
        case actions.UPDATE_AAYU_PLANS:
            return Object.assign({}, state, {
                aayuPlans: action.query
            });
        case actions.UPDATE_AAYU_ALL_PLANS:
            return Object.assign({}, state, {
                aayuAllPlans: action.query
            });
        case actions.UPDATE_PREMIUM_AAYU_PLAN:
            return Object.assign({}, state, {
                premiumAayuCard: action.query
            });
        case actions.UPDATE_CONSULT_PARAMS:
            return Object.assign({}, state, {
                consultationParams: action.query
            });
        case actions.UPDATE_CURRENT_QUESTION:
            return Object.assign({}, state, {
                currentConsultationQuestion: action.query
            });
        case actions.UPDATE_CURRENT_ANSWER:
            return Object.assign({}, state, {
                currentConsultationAnswer: action.query
            });
        case actions.UPDATE_QUESTION_LIST:
            return Object.assign({}, state, {
                consultationQuestion: action.query
            });
        case actions.UPDATE_ANSWER_LIST:
            return Object.assign({}, state, {
                consultationAnswer: action.query
            });
        case actions.UPDATE_QUESTIONRENDER_STATE:
            return Object.assign({}, state, {
                renderQuestionElement: action.query
            })
        case actions.UPDATE_IMAGE_LIST:
            return Object.assign({}, state, {
                consultImageList: action.query
            })
        case actions.UPDATE_ECONSULT_INFO:
            return Object.assign({}, state, {
                eConsultInfo: action.query
            })
        case actions.UPDATE_SELECTED_AAYU_CARD:
            return Object.assign({}, state, {
                selectedAayucard: action.query
            })
        case actions.UPDATE_ADD_UPDATE_SCREEN_DATA:
            return Object.assign({}, state, {
                addUpdateScreenData: action.query
            })
        case actions.UPDATE_DASHBOARD_LOADED_STATUS:
            return Object.assign({}, state, {
                isDashboardLoaded: action.query
            });
        case actions.UPDATE_USER_LOGIN_DETAILS:
            return Object.assign({}, state, {
                userLoginDetails: action.query
            });
        case actions.UPDATE_CONSULTATIONS_LIST:
            return Object.assign({}, state, {
                consultationList: action.query
            });
        case actions.UPDATE_ORDER_LIST:
            return Object.assign({}, state, {
                orderList: action.query
            });
        case actions.UPDATE_SELECTED_LOCATION:
            return Object.assign({}, state, {
                selectedLocation: action.query
            });
        case actions.UPDATE_PREVIOUS_SELECTED_LOCATION:
            return Object.assign({}, state, {
                previousSelectedLocation: action.query
            });
        case actions.UPDATE_PREVIOUS_SELECTED_MEDICINE_CATEGORY:
            return Object.assign({}, state, {
                previousSelectedMedicineCategory: action.query
            });
        case actions.UPDATE_PREVIOUS_SELECTED_MEDICINE:
            return Object.assign({}, state, {
                previousSelectedMedicine: action.query
            });
        case actions.UPDATE_OMS_CART_ITEMS:
            return Object.assign({}, state, {
                cartItemsData: action.query
            });
        case actions.UPDATE_OMS_IMAGES_DATA:
            return Object.assign({}, state, {
                cartImagesData: action.query
            });
        case actions.UPDATE_OMS_REPEAT_ORDER:
            return Object.assign({}, state, {
                repeatOrderData: action.query
            });
        case actions.UPDATE_PHARMACY_DATA:
            return Object.assign({}, state, {
                pharmacyAllData: action.query
            });
        case actions.UPDATE_SELECTED_STORE:
            return Object.assign({}, state, {
                selectedStore: action.query
            });
        case actions.UPDATE_DOWNLOADED_CHAT_IMAGES_LIST:
            return Object.assign({}, state, {
                downloadedChatImagesList: action.query
            })
        case actions.UPDATE_ORDER_INSTRUCTIONS_TO_PHARMACY:
            return Object.assign({}, state, {
                orderInstructions: action.query
            })
        case actions.UPDATE_USER_VISITED_CHEMIST_SITE:
            return Object.assign({}, state, {
                userVisitedStore: action.query
            })
        default: return state
    }
}